export const TableNumbers = (props: {
  children: string;
  className?: string;
  marginTop?: number;
}) => {
  const { children, className, marginTop } = props;
  return (
    <span
      className={`bg-light rounded-circle d-flex align-items-center justify-content-center ${
        className ?? ""
      }`}
      style={{
        width: 30,
        height: 30,
        marginTop: marginTop ?? 6,
      }}
    >
      {children}
    </span>
  );
};
